import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function CreditCardValidationStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				d="M11.5 17.5H12.5M15.5 17.5H18.5"
				stroke="black"
				strokeWidth="1.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2 10.5H9.5"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M8.5 5.5H4C2.89543 5.5 2 6.39543 2 7.5V19.5C2 20.6046 2.89543 21.5 4 21.5H20C21.1046 21.5 22 20.6046 22 19.5V14"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M18.4286 8.21429L17 7.5V5.35714M22 7.5C22 10.2614 19.7614 12.5 17 12.5C14.2386 12.5 12 10.2614 12 7.5C12 4.73857 14.2386 2.5 17 2.5C19.7614 2.5 22 4.73857 22 7.5Z"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

CreditCardValidationStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default CreditCardValidationStrokeIcon;
